exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-btn[data-v-557e3af3]{display:inline-block;margin:0 10px}", ""]);

// exports
